<template>
	<div class="pm">
		<div class="pm__elm">
			<div class="pm__elm-item">
				<IconDoubleChevron />
			</div>

			<div class="pm__elm-item pm__elm-item_green">1</div>
			<div class="pm__elm-item">2</div>
			<div class="pm__elm-item">3</div>
			<div class="pm__elm-item">...</div>
			<div class="pm__elm-item">10</div>

			<div class="pm__elm-item">
				<IconDoubleChevron class="pm__elm-item-chevron_right" />
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import IconDoubleChevron from "@/components/icons/IconDoubleChevron.vue";

@Options({
	components: { IconDoubleChevron },
})
export default class PaginatorMob extends Vue {}
</script>

<style scoped lang="scss">
.pm {
	&__elm {
		display: flex;
		padding: 0 16px;
	}

	&__elm-item {
		display: flex;
		font-size: 13px;
		font-weight: 600;
		align-items: center;
		justify-content: center;
		padding: 8px;
		margin-right: 6px;
		border-radius: 8px;
		border: 1px solid rgb(241, 241, 241);
		background: rgb(255, 255, 255);
		color: rgb(51, 51, 51);
		min-width: 20px;
		min-height: 20px;
		cursor: pointer;
	}

	&__elm-item_green {
		background: var(--theme-color);
		color: rgb(255, 255, 255);
	}

	&__elm-item-chevron_right {
		transform: rotate(0.5turn);
	}
}
</style>
